/**
 * Action types for the contacts feature.
 */
// List operations
export const CONTACTS_LOADED = 'CONTACTS_LOADED';
export const CONTACTS_LOADING = 'CONTACTS_LOADING';
export const CONTACTS_LOAD_FAILED = 'CONTACTS_LOAD_FAILED';
export const CONTACT_ADDED = 'CONTACT_ADDED';
export const CONTACT_UPDATED = 'CONTACT_UPDATED';
export const CONTACT_FAVORITE_CONFIRMED = 'CONTACT_FAVORITE_CONFIRMED';
export const CONTACT_DELETED = 'CONTACT_DELETED';
// Detail / timeline
export const CONTACT_DETAIL_LOADED = 'CONTACT_DETAIL_LOADED';
export const CONTACT_DETAIL_LOADING = 'CONTACT_DETAIL_LOADING';
export const CONTACT_DETAIL_FAILED = 'CONTACT_DETAIL_FAILED';
export const CONTACT_SELECTED = 'CONTACT_SELECTED';
export const CONTACT_DETAIL_CLOSED = 'CONTACT_DETAIL_CLOSED';
// Notes
export const CONTACT_NOTE_ADDED = 'CONTACT_NOTE_ADDED';
export const CONTACT_NOTE_UPDATED = 'CONTACT_NOTE_UPDATED';
export const CONTACT_NOTE_DELETED = 'CONTACT_NOTE_DELETED';
// Groups
export const CONTACT_GROUPS_LOADED = 'CONTACT_GROUPS_LOADED';
export const CONTACT_GROUP_ADDED = 'CONTACT_GROUP_ADDED';
export const CONTACT_GROUP_DELETED = 'CONTACT_GROUP_DELETED';
// Blocked
export const CONTACT_BLOCKED_LOADED = 'CONTACT_BLOCKED_LOADED';
// Sync
export const CONTACTS_SYNC_RECEIVED = 'CONTACTS_SYNC_RECEIVED';
export const CONTACTS_SYNC_TOKEN_UPDATED = 'CONTACTS_SYNC_TOKEN_UPDATED';
// UI
export const CONTACTS_SET_SEARCH = 'CONTACTS_SET_SEARCH';
export const CONTACTS_SET_TAB = 'CONTACTS_SET_TAB';
export const CONTACTS_SET_GROUP_FILTER = 'CONTACTS_SET_GROUP_FILTER';
// Errors
export const CONTACTS_ERROR = 'CONTACTS_ERROR';
export const CONTACTS_CLEAR_ERROR = 'CONTACTS_CLEAR_ERROR';
